import axios from "axios";

/*
 * Exchange rates come from the free "currency-api" by fawazahmed0
 * (https://github.com/fawazahmed0/exchange-api, CC0 1.0 licence, no API key,
 * no rate limit, daily rates, TND supported). Two mirrors are tried in turn.
 *
 * Both methods keep the shape the pages already use: a promise resolving to
 * { data: <rate> } where <rate> is the value of 1 unit of the source currency
 * expressed in the target currency.
 */
const MIRRORS = [
  "https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies",
  "https://latest.currency-api.pages.dev/v1/currencies",
];

const fetchRate = async (from, to) => {
  const source = String(from).toLowerCase();
  const target = String(to).toLowerCase();
  let lastError = null;
  for (const mirror of MIRRORS) {
    try {
      const response = await axios.get(`${mirror}/${source}.json`, { timeout: 8000 });
      const rate = response.data && response.data[source] && response.data[source][target];
      if (typeof rate === "number" && rate > 0) {
        return { ...response, data: rate };
      }
      lastError = new Error(`Taux ${from} -> ${to} indisponible`);
    } catch (error) {
      lastError = error;
    }
  }
  throw lastError;
};

class CurrencyService {
  // 1 <deviseFrom> in TND
  getTauxChage(deviseFrom) {
    return fetchRate(deviseFrom, "TND");
  }
  // 1 TND in <deviseFrom>
  getTauxChageDevise(deviseFrom) {
    return fetchRate("TND", deviseFrom);
  }
}
export default new CurrencyService();
